var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 12.5855 0.561903 11.229 1.5621 10.2288C2.56229 9.22857 3.91885 8.66667 5.33333 8.66667C6.74782 8.66667 8.10438 9.22857 9.10457 10.2288C10.1048 11.229 10.6667 12.5855 10.6667 14H0ZM5.33333 8C3.12333 8 1.33333 6.21 1.33333 4C1.33333 1.79 3.12333 0 5.33333 0C7.54333 0 9.33333 1.79 9.33333 4C9.33333 6.21 7.54333 8 5.33333 8Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStpIcon);
export default __webpack_public_path__ + "static/media/stpIcon.d1e9eaaf42be31c0f88d4dcc49a4805d.svg";
export { ForwardRef as ReactComponent };